"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatThreadsContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const native_base_1 = require("native-base");
const react_1 = require("react");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const react_native_gesture_handler_1 = require("react-native-gesture-handler");
const react_redux_1 = require("react-redux");
const colors_1 = require("../../common/colors");
const AppText_1 = require("../../component/AppText");
const theme_1 = require("../../helper/theme");
const utils_1 = require("../../helper/utils");
const useConversations_1 = require("../../hooks/useConversations");
const useDevice_1 = require("../../hooks/useDevice");
const useRequest_1 = __importDefault(require("../../hooks/useRequest"));
const character_1 = require("../../services/character");
const store_1 = require("../../store");
const user_1 = require("../../store/selectors/user");
const subscription_1 = require("../../store/selectors/subscription");
const user_2 = require("../../slices/user");
const AppLoader_1 = __importDefault(require("../AppLoader"));
const CloseButton_1 = __importDefault(require("../AppButton/CloseButton"));
const ConversationListItem_1 = require("./ConversationListItem");
const ConversationTime_1 = __importDefault(require("./ConversationTime"));
;
;
const ChatThreadsSheet = ({ isOpen, onOpen, onClose, }) => {
    const { isTabOrDesktopDevice, deviceWidth, isPortrait, deviceHeight } = (0, useDevice_1.useDevice)();
    return ((0, jsx_runtime_1.jsx)(react_native_gesture_handler_1.GestureHandlerRootView, { children: (0, jsx_runtime_1.jsx)(native_base_1.Actionsheet, { isOpen: isOpen, onClose: onClose, useRNModal: true, width: isTabOrDesktopDevice ? (isPortrait ? "80%" : "60%") : "100%", bottom: isTabOrDesktopDevice ? "10%" : 0, left: isTabOrDesktopDevice ? (isPortrait ? "10%" : "20%") : 0, hideDragIndicator: true, children: (0, jsx_runtime_1.jsx)(native_base_1.Actionsheet.Content, { bg: colors_1.Colors.DARK_600, rounded: 16, minHeight: isTabOrDesktopDevice
                    ? isPortrait
                        ? (deviceHeight * 40) / 100
                        : (deviceHeight * 60) / 100
                    : (deviceHeight * 50) / 100, padding: 2, paddingTop: 20, children: (0, jsx_runtime_1.jsx)(CloseButton_1.default, { onClose: onClose }) }) }, "userStyleSelect") }));
};
const ChatThreadsContent = ({ onClose, character }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { request } = (0, useRequest_1.default)();
    const { handleCreateInitialConversation } = (0, useConversations_1.useConversations)();
    const userId = (0, react_redux_1.useSelector)(user_1.selectUserId);
    const { conversations: messageQuota } = (0, react_redux_1.useSelector)(subscription_1.selectUserQuota);
    const [chatThreads, setChatThreads] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const isOutQuota = (0, react_1.useMemo)(() => (messageQuota.consumed >= messageQuota.quota), [messageQuota]);
    const threadsIndexesDict = (0, react_1.useMemo)(() => ([...chatThreads]
        .sort((next, prev) => Number(next.id) - Number(prev.id))
        .reduce((indexes, thread, index) => ({ ...indexes, [thread.id]: index }), {})), [chatThreads]);
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        const loadCharacterConversations = () => {
            if (userId) {
                setIsLoading(true);
                request(character_1.getOrCreateConversations, { userId, participantId: character.id.toString() }).then((conversationsResponse) => {
                    if (conversationsResponse && isMounted) {
                        setChatThreads(conversationsResponse.data);
                        setIsLoading(false);
                    }
                });
            }
        };
        loadCharacterConversations();
        return () => { isMounted = false; };
    }, [character, userId]);
    const startNewConversation = (0, react_1.useCallback)(async () => {
        setIsLoading(true);
        handleCreateInitialConversation(character.id, true).then(() => {
            setIsLoading(false);
            onClose?.();
        });
    }, [character, onClose, dispatch]);
    const renderItem = (0, react_1.useCallback)(({ item }) => ((0, jsx_runtime_1.jsx)(ThreadItem, { item: item, index: threadsIndexesDict[item.id], onSelect: onClose }, item.id)), [threadsIndexesDict, onClose]);
    return ((0, jsx_runtime_1.jsxs)(native_base_1.VStack, { width: "100%", paddingX: 4, space: 3, children: [(0, jsx_runtime_1.jsxs)(native_base_1.HStack, { justifyContent: "space-between", children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.WHITE_SECONDARY, fontSize: (0, theme_1.normalize)(32), lineHeight: (0, theme_1.normalize)(34), fontWeight: 600, children: "Threads" }), !isOutQuota && ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { accessible: true, onPress: startNewConversation, style: ({ pressed }) => ([
                            styles.newChatButton,
                            { opacity: pressed ? 0.9 : 1 }
                        ]), children: (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { width: 100, justifyContent: "space-between", alignItems: "center", children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faPlusLarge, color: colors_1.Colors.WHITE_SECONDARY }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.WHITE_SECONDARY, fontSize: (0, theme_1.normalize)(16), numberOfLines: 1, children: "New Chat" })] }) }))] }), (0, jsx_runtime_1.jsx)(native_base_1.FlatList, { data: chatThreads, renderItem: renderItem, contentContainerStyle: styles.listContainer }), (0, jsx_runtime_1.jsx)(AppLoader_1.default, { showLoader: true, isLoading: isLoading })] }));
};
exports.ChatThreadsContent = ChatThreadsContent;
const ThreadItem = (({ item, index, onSelect }) => {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const dispatch = (0, store_1.useAppDispatch)();
    const conversation = (0, react_redux_1.useSelector)(user_1.selectConversation);
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const onSelectChatThread = (0, react_1.useCallback)(async () => {
        onSelect?.();
        dispatch((0, user_2.setConversation)(item));
    }, [item, onSelect]);
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { accessible: true, onPress: onSelectChatThread, style: ({ pressed }) => ([
            styles.threadItemContainer,
            {
                opacity: pressed ? 0.9 : 1,
                transform: isHovered ? 'scale(1.02)' : 'scale(1)'
            }
        ]), onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false), children: (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { backgroundColor: conversation?.id === item?.id
                ? `${colors_1.Colors.PRIMARY_200}`
                : colors_1.Colors.DARK_700, width: "100%", justifyContent: "space-between", paddingX: 5, paddingY: 5, space: 5, borderRadius: 15, children: [(0, jsx_runtime_1.jsxs)(native_base_1.HStack, { width: "80%", space: 3, children: [(0, jsx_runtime_1.jsx)(native_base_1.IconButton, { style: styles.messageIcon, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faMessage, color: colors_1.Colors.WHITE_SECONDARY, size: 20 }) }), (0, jsx_runtime_1.jsx)(native_base_1.Stack, { maxWidth: isMobileScreen ? "100%" : 160, flex: 1, ml: 0, children: item.lastMessage?.isMedia ? ((0, jsx_runtime_1.jsx)(ConversationListItem_1.LastMessage, { message: (0, utils_1.safeText)(item.lastMessage?.message ?? ""), isMedia: item.lastMessage?.isMedia })) : ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { numberOfLines: 1, color: colors_1.Colors.white, fontSize: (0, theme_1.normalize)(18), fontWeight: 500, padding: 0, margin: 0, children: (0, utils_1.safeText)(item.conversationTitle ?? item.lastMessage?.message ?? `Untitled Chat ${index + 1}`) })) })] }), (0, jsx_runtime_1.jsx)(native_base_1.Stack, { width: "20%", children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { numberOfLines: 1, color: colors_1.Colors.DARK_100, fontSize: (0, theme_1.normalize)(16), children: (0, jsx_runtime_1.jsx)(ConversationTime_1.default, { conversation: item, darkTheme: conversation?.id === item?.id }) }) })] }) }));
});
const styles = react_native_1.StyleSheet.create({
    newChatButton: {
        backgroundColor: colors_1.Colors.PRIMARY_BLUE,
        justifyContent: "center",
        alignItems: "center",
        alignContent: "center",
        alignSelf: "center",
        padding: 4,
        paddingHorizontal: 10,
        borderRadius: 12,
    },
    listContainer: {
        marginTop: 10,
        rowGap: 10,
        paddingBottom: 15,
    },
    threadItemContainer: {
        width: '100%',
        borderRadius: 12,
        paddingHorizontal: 10,
        alignContent: "center",
        alignItems: "center",
        alignSelf: "center",
        justifyContent: "center",
    },
    messageIcon: {
        width: 20,
        height: 20,
        alignSelf: "center",
        padding: 0,
        borderRadius: 12,
    }
});
exports.default = (0, react_1.memo)(ChatThreadsSheet);
